export const changegetlocationbysearchReducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_GET_LOC":
      return action.payload.searchLocation;
    default:
      return state;
  }
};
